(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("tracker_portal", [], factory);
	else if(typeof exports === 'object')
		exports["tracker_portal"] = factory();
	else
		root["tracker_portal"] = factory();
})(self, function() {
return 